<template>
  <div id="home" style="height:100%;padding: 14px 40px;box-sizing: border-box;">
    <!-- <div class="table-container"> -->
    <h2 align="center" style="color:green;">部门日工作信息表</h2>
    <div class="form-container">
      <el-row>
        <div class="block" width="50%" style="display:inline-block;float:left">
          <el-date-picker
            v-model="value"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="handleSearch"
            :picker-options="pickerOptions"
            style="width:160px;"
          ></el-date-picker>
          <div class="tbbutton">
            <i class="el-icon-caret-top" @click="beforetime" :class="{'active-tbbutton':sum == 1}"></i>
            <i
              class="el-icon-caret-bottom"
              @click="aftertime"
              :class="{'active-tbbutton':sum == 2}"
            ></i>
          </div>
          <b style="color:#5a691a;margin-right:20px">{{nowWeek}}</b>
          <div style="display:inline-block">
            <el-button
              type="danger"
              size="small"
              @click="checkedDelete"
              v-if="timeFlag=='open' && yshangban=='1'"
            >
              批量删除
              <i class="el-icon-delete"></i>
            </el-button>
            <el-button
              size="small"
              @click="dialogFormVisible = true"
              type="primary"
              v-if="timeFlag=='open' && yshangban=='1'"
            >批量生成</el-button>
            <el-button
              size="small"
              @click="handleAdd"
              type="warning"
              v-if="timeFlag=='open'&& yshangban=='1'"
            >新增部门工作信息</el-button>
          </div>
        </div>
        <div style="display:inline-block;float:right">
          <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
          <el-button size="small" @click="saveAndout" type="primary">《《 返回主页</el-button>
        </div>
        <!-- <el-button type="warning" size="small" @click="handleAdd">增加<i class="el-icon-plus"></i></el-button> -->
        <el-dialog
          title="复制日期选择："
          :visible.sync="dialogFormVisible"
          width="20%"
          v-if="timeFlag=='open'"
        >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">
            <el-date-picker
              v-model="ruleForm.copyDate"
              type="date"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              prop="copyDate"
            ></el-date-picker>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="resetDateForm('ruleForm')">取 消</el-button>
            <el-button type="primary" @click="submitDateForm('ruleForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-row>
      <br />
      <el-table
        id="dailyworkTable"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="80%"
        border
        @selection-change="selectionChange"
        :row-style="{height:'30px'}"
        :row-class-name="tableRowClassName"
      >
        <!-- check-->
        <el-table-column align="center" type="selection" width="34" :selectable="jinzhi"></el-table-column>
        <!-- 姓名 -->
        <el-table-column align="center" label="姓名" min-width="110">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.employee_id"
              size="small"
              @change="update(scope.$index)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
            >
              <el-option
                v-for="item in getData.employee_list"
                :label="item.employee_name"
                :value="item.employee_id"
                :key="item.employee_id"
              ></el-option>
            </el-select>
            <div
              v-else
            >{{ typeof scope.row.rycn == 'undefined'? scope.row.employee_id : scope.row.rycn }}</div>
          </template>
        </el-table-column>
        <!-- 项目名称 -->
        <el-table-column align="center" label="项目名称" prop="project_name_cn" min-width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.xiangmucn"
              size="small"
              @change="gaibianXiangmu(scope.row,scope.$index,$event)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
            >
              <el-option
                v-for="item in xiangmuList"
                :label="item.project_name_cn"
                :value="item.project_id"
                :key="item.project_id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
            <div
              v-else
            >{{ typeof scope.row.xiangmucn == 'undefined'? scope.row.project_id : scope.row.xiangmucn }}</div>
          </template>
        </el-table-column>
        <!-- 阶段部门 -->
        <!-- <el-table-column
          align="center"
          label="阶段部门"
          style="display:inline-block;float:left;"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.depart_id"
              placeholder="请选择"
              size="small"
              popper-class="select-option"
              @change="getjieduan(scope.$index,$event)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
            >
              <el-option
                v-for="item in base_info.depart_list"
                :key="item.depart_id"
                :label="item.depart_name"
                :value="item.depart_id"
              ></el-option>
            </el-select>
            <div v-else>{{ scope.row.bumencn }}</div>
          </template>
        </el-table-column>-->

        <!-- 阶段任务 -->
        <el-table-column align="center" label="阶段任务" min-width="150%">
          <template slot-scope="scope">
            <el-cascader
              size="small"
              style="width:100%"
              v-model="scope.row.value1"
              :options="scope.row.chioes"
              :props="{ expandTrigger: 'hover' }"
              :show-all-levels="false"
              @change="update(scope.$index)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
              :key="cascaderKey"
            ></el-cascader>
            <div v-else>{{scope.row.task_name_str}}</div>
          </template>
        </el-table-column>
        <!-- 工作时长 -->
        <el-table-column align="center" label="工作时长(H:M)" width="120%">
          <template slot-scope="scope" class="elTable">
            <table
              frame="void"
              @change="update(scope.$index)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
            >
              <tr>
                <td>
                  <el-input
                    v-model="scope.row.show_hour"
                    size="small"
                    @change="update(scope.$index)"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="scope.row.show_min"
                    size="small"
                    @change="update(scope.$index)"
                  ></el-input>
                </td>
              </tr>
            </table>
            <div v-else>{{scope.row.show_hour + ":" + scope.row.show_min}}</div>
          </template>
        </el-table-column>
        <!-- 工作内容 -->
        <el-table-column align="center" label="工作内容" width="400%">
          <template slot-scope="scope">
            <el-input
              type="textarea"
              autosize
              v-model="scope.row.comments"
              size="small"
              @change="update(scope.$index)"
              v-if="timeFlag == 'open' && scope.row.is_confirmed == 0"
            ></el-input>
            <div v-else>{{scope.row.comments}}</div>
          </template>
        </el-table-column>
        <!-- 调休确认-->
        <el-table-column align="center" label="调休确认" width="100" :formatter="formtype"></el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" label="操作" width="100%">
          <template slot-scope="scope" v-if="timeFlag == 'open' && scope.row.is_confirmed == 0">
            <button
              @click="singlehandleAdd(scope.$index)"
              style="border: 0;background-color: transparent;outline: none;margin-right: 10px;"
            >
              <i class="el-icon-plus" style="color: blue;font-size:16px;"></i>
            </button>
            <button
              @click="tableDelete(scope.$index)"
              style="border: 0;background-color: transparent;outline: none;"
            >
              <i class="el-icon-delete" style="color: red; font-size:16px"></i>
            </button>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        type="text"
        size="Medium"
        @click="handleAdd"
        v-if="timeFlag == 'open'&& yshangban=='1'"
      >
        <i class="el-icon-plus"></i>新增部门工作信息
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment"; //导入文件
import FileSaver from "file-saver";
import axios from "axios";
import XLSX from "xlsx";
import { showLoading, hideLoading } from "../lib/loading";
import {
  getNextDate,
  getweek,
  myGrounpX,
  gettaskOptions,
  getTaskOptionValue,
  gettasklistStrName,
  getpsheList,
  sfwork
} from "../lib/until";
export default {
  data: function() {
    return {
      dialogFormVisible: false,
      depart_id: "",
      seen: false,
      ID: [], //ID
      value1: [], //获取阶段任务
      options: [], //项目阶段
      value: "", //日期输入框的值
      isPopover: false,
      tableData: [], //table渲染数据
      checked: [], //表格行是否勾选,删除多行用
      showEdit: [false],
      getData: [], //获取的depart_info.php
      daily_report: [], //获取的daily_report_info.php
      base_info: [], //获取的base_info.php的信息
      Message: "", //存储批量生成的日期值
      ruleForm: {
        copyDate: ""
      },
      rules: {
        copyDate: [{ required: true, message: "请输入日期", trigger: "blur" }]
      },
      personId: "",
      nowWeek: "",
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
          return time.getTime() > date;
        }
      },
      sum: "",
      timeFlag: "open",
      xiangmuList: [],
      Active: "",
      yshangban: 1,
      cascaderKey: 0
    };
  },
  created() {
    //从登陆页面获取depart_ID
    this.getuserInfo();
    //加载数据,增加一行昨天的数据，并分配新的daily_report_id
    //this.getyesterdaydata();
    this.getData1();
    this.getnowTime();
  },
  methods: {
    //项目的改变方法
    gaibianXiangmu(row, index, chaevent) {
      //console.log(row);
      //console.log(index);
      //console.log(chaevent);
      row.project_id = chaevent;
      row.value1 = [];
      getpsheList(row).then(res => {
        ++this.cascaderKey;
        row.chioes = [];
        row["chioes"] = gettaskOptions(row.depart_id, this.base_info, res);
      });
    },
    getjieduan(index, val) {
      // console.log(index);
      // console.log(val);
      this.update(index, val);
    },
    // 禁止编辑
    exptime(data1) {
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/paydate.php")
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            if (
              res.data.payment_create_dates &&
              res.data.payment_create_dates.length > 0
            ) {
              var KpiDayList = res.data.payment_create_dates;
              var LastDay = KpiDayList[0];
              var oDate1 = new Date(data1);
              var oDate2 = new Date(LastDay);
              // var oDate2 = new Date("2020-05-26");
              if (oDate1.getTime() < oDate2.getTime()) {
                this.timeFlag = "close";
                //console.log(this.timeFlag);
              } else {
                this.timeFlag = "open";
              }
            }
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    tableRowClassName({ row, rowIndex }) {
      //console.log(row);
      if (row.colorTag === 1) {
        return "warning-row";
      } else if (row.colorTag === 2) {
        return "success-row";
      }
      return "";
    },

    //前一天
    beforetime() {
      this.sum = 1;
      const date = this.value;
      const ceshi = getNextDate(date, -1);
      this.value = ceshi;
      this.nowWeek = getweek(this.value);
      this.handleSearch();
    },
    //后一天
    aftertime() {
      this.sum = 2;
      const date = this.value;
      const now = new Date();
      now.setTime(now.getTime() + 3600 * 1000 * 24 * 7);
      const nowwk = moment(now).format("YYYY-MM-DD");
      // console.log(date < nowtime);
      if (date < nowwk) {
        const ceshi = getNextDate(date, 1);
        this.value = ceshi;
        this.nowWeek = getweek(this.value);
        this.handleSearch();
      }
    },
    //禁止复选框选中
    jinzhi(row, index) {
      return row.is_confirmed == 0;
      //打开编辑页面
    },
    formtype(row) {
      if (row.is_confirmed == 1) {
        return "已确认";
      } else {
        return "";
      }
    },
    //获取当前时间
    getnowTime() {
      let orderId = this.$root.Time;
      //console.log(orderId);
      this.value = orderId;
      this.nowWeek = getweek(this.value);
    },
    // //生成excel表格
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportToExcel() {
      var printdailyworktable = [];
      printdailyworktable = this.getHeadername();

      console.log(printdailyworktable);
      require.ensure([], () => {
        const { export_json_to_excel } = require("../vendor/Export2Excel");
        const tHeader = [
          "日期",
          "姓名",
          "阶段部门",
          "项目",
          "项目阶段",
          "上班时长",
          "工作内容"
        ];
        const filterVal = [
          "date",
          "name",
          "depart",
          "project",
          "phase_task",
          "work_hour",
          "comments"
        ];
        const list = printdailyworktable;
        const data = this.formatJson(filterVal, list);
        var exceldepart_name = "";
        var departIdKeys = Object.keys(this.base_info.depart_list);
        for (var n = 0; n < departIdKeys.length; n++) {
          if (
            this.depart_id ==
            this.base_info.depart_list[departIdKeys[n]].depart_id
          )
            exceldepart_name = this.base_info.depart_list[departIdKeys[n]]
              .depart_name;
        }
        export_json_to_excel(
          tHeader,
          data,
          "部门_日工作_" + this.value + "_" + exceldepart_name
        );
      });
    },
    getHeadername() {
      var printTabledata = [];
      var exceltablerowdata = {
        date: "",
        name: "",
        depart: "",
        project: "",
        phase_task: "",
        work_hour: "",
        comments: ""
      };

      //获取id对应的中文名称
      for (var i = 0; i < this.tableData.length; i++) {
        let tablerowdata = Object.assign({}, exceltablerowdata);
        for (let key in this.base_info.employee_all_list) {
          if (
            this.tableData[i].employee_id ==
            this.base_info.employee_all_list[key].employee_id
          ) {
            tablerowdata.name = this.base_info.employee_all_list[
              key
            ].employee_name;
          }
        }
        for (let key in this.base_info.project_list) {
          if (
            this.tableData[i].project_id ==
            this.base_info.project_list[key].project_id
          ) {
            tablerowdata.project = this.base_info.project_list[
              key
            ].project_name_cn;
          }
        }

        tablerowdata.depart = this.tableData[i].bumencn;
        tablerowdata.phase_task = this.tableData[i].task_name_str;
        tablerowdata.work_hour = this.tableData[i].work_hour;
        tablerowdata.comments = this.tableData[i].comments;
        tablerowdata.date = this.value;
        //console.log(tablerowdata);
        printTabledata.push(tablerowdata);
        tablerowdata = {};
      }
      return printTabledata;
    },
    //保存并退出到主页
    saveAndout() {
      this.$router.push({
        path: "/Preson"
      });
    },
    //单个人添加
    singlehandleAdd(index) {
      let singleAdd = Object.assign({}, this.tableData[index]);
      var employee_id = this.tableData[index].employee_id;
      var sumHours = this.getEmployeeWorkHoursSum(employee_id);
      var remainHours = 8 - sumHours;
      singleAdd.work_hour = remainHours.toString();
      this.hourToMin(singleAdd);
      singleAdd.daily_report_id = -1;
      var i = index + 1;
      this.tableData.splice(i, 0, singleAdd);
      this.update(i);
    },
    //批量生成
    // 提交事件
    submitDateForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //console.log(this.ruleForm.copyDate);
          var sendCopyMsg = {
            depart_id: this.depart_id,
            daily_report_date: this.value,
            copy_from_date: this.ruleForm.copyDate
          };

          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/copy.php",
              JSON.stringify(sendCopyMsg)
            )
            .then(
              function(results) {
                var txtResult = [];
                txtResult = results.body;
                this.handleSearch();
              },
              function(results) {
                //console.log(results.status);
              }
            );
          this.dialogFormVisible = false; // 提交成功后隐藏弹窗
        } else {
          this.$Message.error("请输入日期");
          return false;
        }
      });
    },
    // 取消事件
    resetDateForm(formName) {
      this.dialogFormVisible = false; // 点击取消隐藏弹窗
    },
    //获取depart_ID
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      // this.personId = uesrInfo.employee_id;
      // this.qxlist = uesrInfo.qxianlist;
      // this.password = uesrInfo.password;
      //console.log(this.password);
    },
    //获取数据
    getData1() {
      //获取base_info.php
      this.$http
        .get(IPConfig.IP + "/kpi-management/info/base_info.php", {
          //params: { encodeout: "utf-8" }

        })
        .then(function(results) {
          this.base_info = results.body;

          //部门数组
          let bmlist = results.body.project_list;
          let newbmlist = Object.assign({}, bmlist);
          let newlist = [];
          for (let key in newbmlist) {
            if (0 == newbmlist[key].all_payed) {
              newlist.push(newbmlist[key]);
            }
          }
          //console.log(newbmlist);
          this.xiangmuList = newlist;
          this.xiangmuList.sort(function(a, b) {
            return a.order_id - b.order_id;
          });
          //获取depart_info.php
          this.$http
            .get(
              IPConfig.IP +
                "/kpi-management/info/depart_info.php?depart_id=" +
                this.depart_id +
                "",
              { //params: { encodeout: "utf-8" }
 }
            )
            .then(function(results) {
              this.getData = results.body;
              this.handleSearch();
            });
        });
    },
    //按日期主管搜索
    handleSearch() {
      if (this.value != "") {
        this.$root.Time = this.value;
        //console.log(this.$root.Time);
      }
      this.nowWeek = getweek(this.value);
      sfwork(this.value).then(res => {
        this.yshangban = res;
      });
      this.exptime(this.value);
      var searchtime = this.value;
      this.$http
        .get(
          IPConfig.IP +
            "/kpi-management/info/daily_report_info.php?depart_id=" +
            this.depart_id +
            "&daily_report_date=" +
            searchtime +
            "",
          { //params: { encodeout: "utf-8" }
 }
        )
        .then(function(results) {
          showLoading();
          this.tableData = [];
          var searchMsg = results.body;
          var valueList = Object.values(results.body.daily_report_list).sort(
            function(a, b) {
              return a.employee_id - b.employee_id;
            }
          );
          //console.log(valueList);
          this.search(valueList);
          //console.log(searchMsg);
          //this.search(searchMsg.daily_report_list);
        });
    },
    //搜索更新数据
    search(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        //console.log(typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0);
        hideLoading();
        return;
      }
      //console.log(getDailyMsg);
      var tableList = [];
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }
        //获取人员
        for (let key in this.base_info.employee_all_list) {
          //console.log(key);
          if (vms.employee_id == key) {
            vms["rycn"] = this.base_info.employee_all_list[key].employee_name;
          }
        }

        getpsheList(vms).then(res => {
          //console.log(res);
          vms["chioes"] = gettaskOptions(vms.depart_id, this.base_info, res);
          let chioseList = vms["chioes"];
          vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
          var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
          var scopeName = [];
          Object.assign(scopeName, vms["value1"]);
          if (scopeName.length > 0) {
            vms["task_name_str"] = gettasklistStrName(
              vms.task_id,
              scopeName,
              taskoptions
            );
          } else {
            vms["task_name_str"] = vms.task_id;
          }

          this.hourToMin(vms);
          tableList.push(vms);
          this.tableData = Object.values(tableList).sort(function(a, b) {
            return a.employee_id - b.employee_id;
          });
          //console.log(this.tableData);
          myGrounpX(this.tableData);
          hideLoading();
        });
      }

      //console.log(typeof this.tableData);
    },
    hourToMin(vms) {
      //将小时转换成小时和分钟
      var hour = vms.work_hour;
      var int_hour = hour.split(".");
      var show_min = ((Number(hour) - Number(int_hour[0])) * 60).toFixed(0);
      var h = Number(int_hour[0]);
      vms["show_hour"] = String(h);
      vms["show_min"] = String(show_min);
    },
    checkInput(vms) {
      if (isNaN(Number(vms.show_hour))) {
        vms.show_hour = "0";
      }
      var tempMin = Number(vms.show_min);
      if (isNaN(tempMin) || tempMin < 0) {
        vms.show_min = "0";
      } else if (tempMin > 59) {
        vms.show_min = "59";
      }
    },
    //提交数据
    update(index, xzdepartid) {
      var Msg = this.tableData[index];
      this.checkInput(Msg);
      Msg.work_hour = 0;
      var otherHourSum = this.getEmployeeWorkHoursSum(Msg.employee_id);
      this.minToHour(Msg);
      var totalSum = Number(Msg.work_hour) + otherHourSum;
      if (totalSum > 8) {
        // alert("工作时长总和超8小时请修改");
        this.Active = 1;
        //window.localStorage.setItem("liang",this.Active);
      } else {
        this.Active = 0;
        //window.localStorage.removeItem("liang");
      }
      if (xzdepartid) {
        //console.log(111);
        Msg.depart_id = xzdepartid;
        Msg.chioes = [];
        Msg.chioes = gettaskOptions(xzdepartid, this.base_info);
        //console.log(Msg);
      } else {
        Msg.daily_report_date = this.value;
        //phase-id与project-id
        if (Msg.daily_report_id != -1) {
          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/update.php",
              JSON.stringify(this.updateJSONmsg(Msg)),
              { emulateJSON: true }
            )
            .then();
        } else if (
          Msg.employee_id != "" &&
          Msg.project_id != "" &&
          Msg.value1.length != 0 &&
          Msg.comments != "" &&
          Msg.show_hour != "" &&
          Msg.show_min != ""
        ) {
          //console.log("获取")
          var addMsg = this.updateJSONmsg(Msg);
          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/create.php",
              JSON.stringify(addMsg),
              { emulateJSON: true }
            )
            .then(function(res) {
              var getDaily_report_id = res.body;
              addMsg.daily_report_id = getDaily_report_id.daily_report_id;
              this.$http
                .post(
                  IPConfig.IP + "/kpi-management/dailyreport/update.php",
                  JSON.stringify(addMsg),
                  { emulateJSON: true }
                )
                .then(function(res) {
                  myGrounpX(this.tableData);
                  //console.log(res.body);
                });
            });
        }
      }
      //console.log("this.tableData", this.tableData);
    },
    minToHour(vms) {
      //work_hour格式化
      var hourvalue = Number(vms.show_hour) + Number(vms.show_min) / 60;
      vms.work_hour = String(hourvalue.toFixed(3));
    },
    updateJSONmsg(updateMsg) {
      if (updateMsg.value1.length == 3) {
        updateMsg.task_id = updateMsg.value1[2];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      if (updateMsg.value1.length == 2) {
        updateMsg.task_id = updateMsg.value1[1];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      //转成JSON数据
      return updateMsg;
      //发送数据
    },
    //打印value1
    printvalue1(value1) {
      //console.log(value1);
    },
    //单行删除按钮
    tableDelete(index) {
      this.$confirm("确定删除这条记录吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var deleteMsg = {
            delete_report_list: [
              {
                daily_report_id: 0
              }
            ]
          };
          deleteMsg.delete_report_list[0].daily_report_id = this.tableData[
            index
          ].daily_report_id;
          this.tableData.splice(index, 1);
          //alert(this.tableData[index].daily_report_id);
          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/delete.php",
              JSON.stringify(deleteMsg),
              { emulateJSON: true }
            )
            .then(
              function(res) {
                //console.log(res.body);
              },
              function(res) {
                //console.log(res.status);
              }
            );
          this.$message({
            type: "success",
            message: "删除成功!",
            duration: "500"
          });
        })
        .catch(() => {});
      //console.log(this.tableData[index].daily_report_id);
    },
    //多行删除时用
    checkedDelete() {
      this.$confirm("确定批量删除数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var deleterowReportID = {
            daily_report_id: -1
          };
          var delete_report_list = {
            delete_report_list: []
          };
          this.checked.forEach(function(value) {
            //console.log(value.daily_report_id);
            deleterowReportID.daily_report_id = value.daily_report_id;
            delete_report_list.delete_report_list.push(deleterowReportID);
            this.$http
              .post(
                IPConfig.IP + "/kpi-management/dailyreport/delete.php",
                JSON.stringify(delete_report_list),
                { emulateJSON: true }
              )
              .then(
                function(res) {
                  //console.log(res.body);
                },
                function(res) {
                  //console.log(res.status);
                }
              );
            this.tableData.splice(this.tableData.indexOf(value), 1);
          }, this);

          this.$message({
            type: "success",
            message: "删除成功!",
            duration: "500"
          });
        })
        .catch(() => {});
      //console.log(this.checked);
    },
    selectionChange(selection) {
      this.checked = selection;
    },
    //增加行
    handleAdd() {
      var v = {
        employee_id: "",
        employee_name: "",
        project_id: "",
        task_id: "",
        daily_report_id: -1,
        phase_id: "",
        value1: [],
        work_hour: "",
        show_hour: "0",
        show_min: "0",
        overtimework: false,
        comments: "空",
        is_confirmed: 0,
        depart_id: this.depart_id,
        chioes: []
      };
      this.tableData.push(v);
      this.$nextTick(() => {
        this.$refs.multipleTable.bodyWrapper.scrollTop = this.$refs.multipleTable.bodyWrapper.scrollHeight;
      });

      ////console.log(this.tableData);
    },
    getEmployeeWorkHoursSum(employee_id) {
      var sum = 0;
      for (var i = 0; i < this.tableData.length; i++) {
        if (employee_id == this.tableData[i].employee_id) {
          sum += Number(this.tableData[i].work_hour);
        }
      }
      return sum;
    }
  }
};
</script>

<style scoped lang="less">
.page-title {
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}
.breadcrumb {
  background-color: white;
  padding: 0.5rem;
  margin-bottom: 25px;
}
.table-container {
  border: 1px solid blue;
}
.form-container {
  padding: 10px;
  height: 90%;
}
.form-title {
  background-color: blue;
  color: white;
  padding: 0.5rem;
  text-align: left;
  margin-bottom: 5px;
}
.btn-container {
  overflow: hidden;
  .el-button {
    float: left;
  }
}
.search-input {
  width: 300px;
  float: left;
  margin-left: 10px;
  margin-right: 5px;
}
.el-table__body {
  td {
    padding: 0;
  }
}
.myClass {
  border: 1px red solid !important;
}
</style>











// WEBPACK FOOTER //
// src/components/departwork.vue